import API from "./axios"



/////////////////////////////////////////////////////
// PLACE ORDER
/////////////////////////////////////////////////////

export const placeOrderApi = (data) =>
  API.post("/place_order", data)

/////////////////////////////////////////////////////
// GET USER ORDERS
/////////////////////////////////////////////////////

export const getOrdersApi = () =>
  API.get("/get_orders")

/////////////////////////////////////////////////////
// GET ORDER DETAILS
/////////////////////////////////////////////////////

export const getOrderDetailsApi = (data) =>
  API.post("/get_order_details", data)

/////////////////////////////////////////////////////
// VALIDATE ADDRESS
/////////////////////////////////////////////////////

export const validateAddressApi = (data) =>
  API.post("/validate_address", data)

/////////////////////////////////////////////////////
// GET ORDER HISTORY
/////////////////////////////////////////////////////

export const getOrderHistoryApi = (data) =>
  API.post("/get_order_history", data)


/////////////////////////////////////////////////////
// UPDATE ORDER STATUS (ADMIN)
/////////////////////////////////////////////////////

export const updateOrderStatusApi = (data) =>
  API.post("/update_order_status", data)


/////////////////////////////////////////////////////
// ADMIN ORDERS
/////////////////////////////////////////////////////

export const getOrdersAdminApi = () =>
  API.get("/get_orders_admin")




/////////////////////////////////////////////////////
// GET CHECKOUT TOTALS
/////////////////////////////////////////////////////

export const getCheckoutTotalsApi = (data) =>
  API.post("/get_checkout_totals", data)




/////////////////////////////////////////////////////
// VERIFY PAYMENT
/////////////////////////////////////////////////////

export const verifyPaymentApi = (data) =>
  API.post("/verify_payment", data)


/////////////////////////////////////////////////////
// RETRY PAYMENT
/////////////////////////////////////////////////////

export const retryPaymentApi = (data) =>
  API.post("/retry_payment", data)


/////////////////////////////////////////////////////
// FETCH PAYMENT AFTER PAYMENT
/////////////////////////////////////////////////////

export const fetchPaymentAfterPaymentApi = (data) =>
  API.post("/fetch_payment_after_payment", data)


/////////////////////////////////////////////////////
// CAPTURE ORDER PAYMENT (ADMIN)
/////////////////////////////////////////////////////

export const captureOrderPaymentApi = (data) =>
  API.post("/capture_order_payment", data)


/////////////////////////////////////////////////////
// ADMIN UPDATE PAYMENT
/////////////////////////////////////////////////////

export const adminUpdatePaymentApi = (data) =>
  API.post("/admin_update_payment", data)


/////////////////////////////////////////////////////
// UPDATE ORDER PAYMENT STATUS
/////////////////////////////////////////////////////

export const updateOrderPaymentStatusApi = (data) =>
  API.post("/update_order_payment_status", data)


/////////////////////////////////////////////////////
// GET PAYMENT HISTORY BY PAYMENT
/////////////////////////////////////////////////////

export const getPaymentHistoryApi = (data) =>
  API.post("/get_payment_history_by_payment", data)



